<template>
  <div class="w-100">
    <custom-tabs grow :tab-items="tabs" v-model="tab">
      <template v-slot:staticItems>
        <v-tab-item>
          <commercial-admin :qrland="qrland" />
        </v-tab-item>
        <v-tab-item>
          <commercial-admin-manage :admin="admin" :qrland="qrland" />
        </v-tab-item>
        <v-tab-item>
          <commercial-reserve-admin />
        </v-tab-item>
      </template>
    </custom-tabs>
  </div>
</template>

<script>
import commercialAdmin from "./commercialAdmin.vue";
import CommercialAdminManage from "./commercialAdminManage.vue";
import commercialReserveAdmin from "./commercialReserveAdmin.vue";
export default {
  components: {
    commercialAdmin,
    CommercialAdminManage,
    commercialReserveAdmin,
  },
  props: {
    qrland: Number,
    value: [Object, Array, null],
    admin: Boolean,
  },
  name: "partnershipAdmin",
  data() {
    return {
      tabs: [
        { text: "مدیریت پرداخت ها", value: "price", icon: "" },
        { text: "مدیریت کاربران", value: "price", icon: "" },
        { text: "مدیریت  درخواست ها", value: "price", icon: "" },
      ],
      tab: null,
    };
  },
};
</script>

<style></style>
